import React from "react";
import { Link } from "react-router-dom";
import { Crown, RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { CONTACT_EMAIL, PRIVACY_PATH, REGULATION_PATH } from "@/content/siteContent";
import { usePageSEO } from "@/hooks/usePageSEO";

export default function PaymentCancelPage() {
  usePageSEO({
    title: "Checkout annullato",
    description: "Pagamento ticket Fanta Royal non completato. Pagina di annullamento checkout con possibilità di riprovare.",
    canonicalPath: "/cancel",
    noindex: true,
  });

  return (
    <div className="status-page-shell page-noise">
      <div className="status-page-inner">
        <Link to="/" className="brand-lockup" data-testid="cancel-page-home-link">
          <span className="brand-mark" aria-hidden="true">
            <Crown className="h-4 w-4" />
          </span>
          <div>
            <span className="wordmark">Fanta Royal</span>
            <p className="brand-tagline">Conquista la corona</p>
          </div>
        </Link>

        <Card className="luxury-card status-card" data-testid="payment-cancel-card">
          <CardContent className="p-6 sm:p-8">
            <div className="status-icon cancel">
              <RotateCcw className="h-8 w-8" />
            </div>
            <span className="section-kicker">Checkout interrotto</span>
            <h1 className="section-title status-title">Il pagamento non è stato completato</h1>
            <p className="section-description status-copy" data-testid="payment-cancel-message">
              Nessun ordine è stato marcato come pagato. Puoi tornare alla sezione ticket, rileggere Regolamento e Privacy e riprovare quando vuoi.
            </p>

            <div className="status-actions">
              <Button asChild className="primary-cta">
                <Link to="/#ticket" data-testid="payment-cancel-primary-cta">Riprova acquisto</Link>
              </Button>
              <Button asChild variant="outline" className="secondary-cta">
                <Link to={REGULATION_PATH} data-testid="payment-cancel-regulation-link">Regolamento</Link>
              </Button>
            </div>

            <div className="status-utility-links">
              <Link to={PRIVACY_PATH} className="footer-link" data-testid="payment-cancel-privacy-link">
                Privacy Policy
              </Link>
              <a href={`mailto:${CONTACT_EMAIL}`} className="footer-link" data-testid="payment-cancel-contact-link">
                {CONTACT_EMAIL}
              </a>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
